import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function Login({ setOpen, onLoginSuccess }) {
  const [phone, setPhone] = useState("");
  const [step, setStep] = useState("phone");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const inputsRef = useRef([]);
  const navigate = useNavigate();

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) setPhone(value);
    setError("");
  };

  const handleContinue = async () => {
    if (phone.length === 10) {
      setLoading(true);
      setError("");
      
      try {
        // Format phone number with country code
        const phoneWithCode = "91" + phone;
        
        const response = await fetch("https://evercorenutrition.com/ev_admin/api/send-otp/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phone: phoneWithCode
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Failed to send OTP");
        }

        // Move to OTP step on success
        setStep("otp");
        setTimer(60);
        
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
  };

  // const handleOtpChange = (value, index) => {
  //   if (!/^\d?$/.test(value)) return;

  //   const newOtp = [...otp];
  //   newOtp[index] = value;
  //   setOtp(newOtp);
  //   setError("");

  //   if (value && index < 5) {
  //     inputsRef.current[index + 1].focus();
  //   }
  // };

const handleOtpChange = (value, index) => {
  const digitsOnly = value.replace(/\D/g, "");
  if (value !== "" && digitsOnly === "") return; // blocks letters/symbols, allows clearing the box

  const newOtp = [...otp];
  newOtp[index] = digitsOnly.slice(-1); // only ever 1 digit or empty string
  setOtp(newOtp);
  setError("");

  if (digitsOnly && index < 5) {
    inputsRef.current[index + 1].focus();
  }
};

const handleOtpPaste = (e) => {
  e.preventDefault();
  const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
  if (!pasted) return;

  const newOtp = ["", "", "", "", "", ""];
  for (let i = 0; i < pasted.length; i++) {
    newOtp[i] = pasted[i];
  }
  setOtp(newOtp);

  const nextIndex = Math.min(pasted.length, 5);
  inputsRef.current[nextIndex]?.focus();
};

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) return;

    setLoading(true);
    setError("");

    try {
      // Format phone number with country code
      const phoneWithCode = "91" + phone;
      
      const response = await fetch("https://evercorenutrition.com/ev_admin/api/verify-otp/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phone: phoneWithCode,
          otp: enteredOtp
        }),
      });

      const data = await response.json();
      // console.log('Login API Response:', data); // Debug log

      if (!response.ok) {
        throw new Error(data.message || "OTP verification failed");
      }

      if (data.success && data.access) {
        // Store authentication tokens
        localStorage.setItem("authToken", data.access);
        
        // Store refresh token if available
        if (data.refresh) {
          localStorage.setItem("refreshToken", data.refresh);
        }
        
        // ========== FIX: Get customer ID from all possible locations ==========
        let customerId = null;
        
        // Check all possible places where customer ID might be
        if (data.customer_id) {
          customerId = data.customer_id;
        } else if (data.user?.id) {
          customerId = data.user.id;
        } else if (data.customer?.id) {
          customerId = data.customer.id;
        } else if (data.id) {
          customerId = data.id;
        }
        
        // Store customer ID separately (this is working in your image)
        if (customerId) {
          localStorage.setItem("customer_id", customerId);
          // console.log('Customer ID stored separately:', customerId);
        } else {
          console.warn('No customer ID found in response:', data);
        }
        
        // ========== FIX: Build complete user data object ==========
        const userData = {
          phone: phone,
          phoneWithCode: phoneWithCode,
        };
        
        // Add customer ID to userData if available
        if (customerId) {
          userData.id = customerId;
          userData.customer_id = customerId;
        }
        
        // Merge with any user/customer data from response
        if (data.user && typeof data.user === 'object') {
          Object.assign(userData, data.user);
        }
        
        if (data.customer && typeof data.customer === 'object') {
          Object.assign(userData, data.customer);
        }
        
        if (data.user_data && typeof data.user_data === 'object') {
          Object.assign(userData, data.user_data);
        }
        
        // If response has direct user fields, add those too
        if (data.email && !userData.email) {
          userData.email = data.email;
        }
        
        if (data.name && !userData.name) {
          userData.name = data.name;
        }
        
        if (data.first_name && !userData.first_name) {
          userData.first_name = data.first_name;
        }
        
        if (data.last_name && !userData.last_name) {
          userData.last_name = data.last_name;
        }
        
        // Store complete user data
        localStorage.setItem("userData", JSON.stringify(userData));
        // console.log('Complete user data stored:', userData);
        
        // Store user email if available
        if (data.user?.email || data.customer?.email || data.email) {
          const email = data.user?.email || data.customer?.email || data.email;
          localStorage.setItem("user_email", email);
        }
        
        // Store user name if available
        if (data.user?.name || data.customer?.name || data.name || data.first_name) {
          const name = data.user?.name || data.customer?.name || data.name || 
                      (data.first_name && data.last_name ? `${data.first_name} ${data.last_name}` : data.first_name);
          if (name) {
            localStorage.setItem("user_name", name);
          }
        }
        
        // Store is_new_user flag if needed
        if (data.is_new_user) {
          localStorage.setItem("is_new_user", data.is_new_user);
        }

        // Close modal
        setOpen(false);
        
        // Call the success callback if provided with the full data
        if (onLoginSuccess) {
          onLoginSuccess({
            ...data,
            user: userData,
            customer_id: customerId
          });
        }
        
        // Navigate to home page
        navigate("/");
      } else {
        throw new Error("Invalid response structure from server");
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (step === "otp" && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [step, timer]);

  const formatTime = () => {
    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const handleResendOtp = async () => {
    setTimer(30);
    setOtp(["", "", "", "", "", ""]);
    setError("");
    setLoading(true);
    
    try {
      const phoneWithCode = "91" + phone;
      
      const response = await fetch("https://evercorenutrition.com/ev_admin/api/send-otp/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phone: phoneWithCode
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to resend OTP");
      }
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="login-overlay" onTouchStart={(e) => e.stopPropagation()}
  onClick={(e) => e.stopPropagation()}>
        <div className="login-card" onTouchStart={(e) => e.stopPropagation()}
    onClick={(e) => e.stopPropagation()}>
          <button className="close-btn" onClick={() => setOpen(false)}>
            ×
          </button>

          <div className="text-center mb-4">
            <img 
              src='/assets/images/EC.png' 
              alt='Evercore Nutrition' 
              style={{ height: "70px", objectFit: "contain" }} 
            />
            <h2 className="brand-title" style={{ 
              fontSize: "24px", 
              fontWeight: "700", 
              marginTop: "10px",
              color: "#1a1a1a"
            }}>
              Evercore Nutrition
            </h2>
            <p className="brand-subtitle" style={{ 
              color: "#666", 
              fontSize: "14px",
              marginTop: "-5px"
            }}>
              Advanced Nutrition. Enhanced Performance.
            </p>
          </div>

          {error && (
            <div className="alert alert-danger" style={{
              backgroundColor: "#fef2f2",
              color: "#dc2626",
              padding: "12px",
              borderRadius: "10px",
              marginBottom: "20px",
              fontSize: "14px",
              border: "1px solid #fecaca",
              textAlign: "center"
            }}>
              {error}
            </div>
          )}

          {step === "phone" && (
            <>
              <div className="welcome-text mb-4">
                <h3 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "5px", color: "#1a1a1a" }}>
                  Welcome Back
                </h3>
                <p style={{ color: "#666", fontSize: "14px" }}>
                  Please enter your mobile number to continue
                </p>
              </div>

              <div className="phone-input-wrapper" style={{ marginBottom: "20px" }}>
                <label style={{ 
                  display: "block", 
                  fontSize: "14px", 
                  fontWeight: "500", 
                  marginBottom: "8px",
                  color: "#444"
                }}>
                  Mobile Number
                </label>
                <div className="phone-input" style={{
                  display: "flex",
                  alignItems: "center",
                  border: "2px solid #e5e7eb",
                  borderRadius: "12px",
                  overflow: "hidden",
                  background: "#f9fafb",
                  transition: "border-color 0.3s ease",
                  
                }}>
                  <span style={{
                    padding: "14px 16px",
                    background: "#f3f4f6",
                    fontWeight: "600",
                    color: "#374151",
                    borderRight: "2px solid #e5e7eb",
                    fontSize: "15px"
                  }}>
                    +91
                  </span>
<input
  type="tel"
  value={phone}
  onChange={handlePhoneChange}
  placeholder="98765 43210"
  maxLength={10}
  disabled={loading}
  autoComplete="tel"
  style={{
    flex: 1,
    padding: "14px 16px",
    border: "none",
    outline: "none",
    fontSize: "16px",
    background: "transparent",
    color: "#1f2937",
    WebkitAppearance: "none",
    touchAction: "manipulation",
  }}
/>
                </div>
              </div>

              <button
                className="primary-btn"
                disabled={phone.length !== 10 || loading}
                onClick={handleContinue}
                style={{
                  width: "100%",
                  padding: "16px",
                  background: phone.length === 10 && !loading ? "#4b4b4b" : "#9ca3af",
                  color: "white",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: phone.length === 10 && !loading ? "pointer" : "not-allowed",
                  transition: "all 0.3s ease",
                  boxShadow: phone.length === 10 && !loading ? "0 4px 6px -1px rgba(37, 99, 235, 0.2)" : "none"
                }}
                onMouseEnter={(e) => {
                  if (phone.length === 10 && !loading) {
                    e.target.style.background = "#000000";
                  }
                }}
                onMouseLeave={(e) => {
                  if (phone.length === 10 && !loading) {
                    e.target.style.background = "#000000";
                  }
                }}
              >
                {loading ? "Sending OTP..." : "Continue"}
              </button>
            </>
          )}

          {step === "otp" && (
            <>
              <div className="otp-header text-center mb-4">
                <h3 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "5px", color: "#1a1a1a" }}>
                  Verify OTP
                </h3>
                <p className="otp-text" style={{ color: "#666", fontSize: "14px" }}>
                  We've sent a verification code to
                </p>
                <p style={{ 
                  fontWeight: "600", 
                  color: "#000000", 
                  fontSize: "18px",
                  background: "#eff6ff",
                  display: "inline-block",
                  padding: "4px 16px",
                  borderRadius: "20px",
                  marginTop: "5px"
                }}>
                  +91 {phone}
                </p>
              </div>

              <div className="otp-box" style={{
                display: "flex",
                gap: "8px",
                justifyContent: "center",
                marginBottom: "20px",
                
              }}>
                {otp.map((digit, index) => (
                  // <input
                  //   key={index}
                  //   type="text"
                  //   maxLength="1"
                  //   value={digit}
                  //   ref={(el) => (inputsRef.current[index] = el)}
                  //   onChange={(e) => handleOtpChange(e.target.value, index)}
                  //   onKeyDown={(e) => handleKeyDown(e, index)}
                  //   disabled={loading}
                  //   style={{
                  //     width: "42px",
                  //     height: "44px",
                  //     textAlign: "center",
                  //     fontSize: "24px",
                  //     fontWeight: "600",
                  //     border: `2px solid ${digit ? "#333333" : "#e5e7eb"}`,
                  //     borderRadius: "12px",
                  //     outline: "none",
                  //     background: loading ? "#f3f4f6" : "#ffffff",
                  //     transition: "all 0.2s ease",
                  //     color: "#1f2937",
                  //     boxShadow: digit ? "0 2px 4px rgba(37, 99, 235, 0.1)" : "none"
                  //   }}
                  //   onFocus={(e) => {
                  //     e.target.style.borderColor = "#000000";
                  //     e.target.style.boxShadow = "0 0 0 3px rgba(37, 99, 235, 0.1)";
                  //   }}
                  //   onBlur={(e) => {
                  //     e.target.style.borderColor = digit ? "#000000" : "#e5e7eb";
                  //     e.target.style.boxShadow = "none";
                  //   }}
                  // />


                  <input
                      key={index}
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength="1"
                      value={digit}
                      ref={(el) => (inputsRef.current[index] = el)}
                      onChange={(e) => handleOtpChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={handleOtpPaste}
                      disabled={loading}
                      style={{
                        width: "42px",
                        height: "44px",
                        textAlign: "center",
                        fontSize: "24px",
                        fontWeight: "600",
                        border: `2px solid ${digit ? "#333333" : "#e5e7eb"}`,
                        borderRadius: "12px",
                        outline: "none",
                        background: loading ? "#f3f4f6" : "#ffffff",
                        transition: "all 0.2s ease",
                        color: "#1f2937",
                        boxShadow: digit ? "0 2px 4px rgba(37, 99, 235, 0.1)" : "none"
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#000000";
                        e.target.style.boxShadow = "0 0 0 3px rgba(37, 99, 235, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = digit ? "#000000" : "#e5e7eb";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                ))}
              </div>

              <div className="timer text-center mb-4" style={{
                color: timer === 0 ? "#dc2626" : "#4b5563",
                fontSize: "15px",
                fontWeight: "500",
                background: "#f3f4f6",
                padding: "8px",
                borderRadius: "8px",
                display: "inline-block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "auto",
                paddingLeft: "16px",
                paddingRight: "16px"
              }}>
                {timer > 0 ? (
                  <>
                    <span style={{ marginRight: "4px" }}>⏱</span>
                    Code expires in {formatTime()}
                  </>
                ) : (
                  " OTP expired"
                )}
              </div>

              <button
                className="primary-btn"
                disabled={otp.join("").length !== 6 || loading}
                onClick={handleVerifyOtp}
                style={{
                  width: "100%",
                  padding: "16px",
                  background: otp.join("").length === 6 && !loading ? "#3d3b3b" : "#9ca3af",
                  color: "white",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: otp.join("").length === 6 && !loading ? "pointer" : "not-allowed",
                  transition: "all 0.3s ease",
                  marginBottom: "15px",
                  boxShadow: otp.join("").length === 6 && !loading ? "0 4px 6px -1px rgba(37, 99, 235, 0.2)" : "none"
                }}
                onMouseEnter={(e) => {
                  if (otp.join("").length === 6 && !loading) {
                    e.target.style.background = "#000000";
                  }
                }}
                onMouseLeave={(e) => {
                  if (otp.join("").length === 6 && !loading) {
                    e.target.style.background = "#000000";
                  }
                }}
              >
                {loading ? "Verifying..." : "Verify & Login"}
              </button>

              {timer === 0 && (
                <div className="resend text-center">
                  <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "10px" }}>
                    Didn't receive the code?
                  </p>
                  <button
                    onClick={handleResendOtp}
                    disabled={loading}
                    style={{
                      background: "white",
                      border: "2px solid #333232",
                      color: "#000000",
                      padding: "10px 30px",
                      borderRadius: "10px",
                      fontSize: "15px",
                      fontWeight: "600",
                      cursor: loading ? "not-allowed" : "pointer",
                      opacity: loading ? 0.5 : 1,
                      transition: "all 0.3s ease"
                    }}
                    onMouseEnter={(e) => {
                      if (!loading) {
                        e.target.style.background = "#000000";
                        e.target.style.color = "white";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!loading) {
                        e.target.style.background = "white";
                        e.target.style.color = "#000000";
                      }
                    }}
                  >
                    {loading ? "Sending..." : "Resend OTP"}
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <style>{`
.login-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  -webkit-overflow-scrolling: touch;
}

/* Use pseudo-element for blur so it doesn't block inputs */
.login-overlay::before {
  content: '';
  position: fixed;
  inset: 0;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: -1;
}

.login-card {
  background: white;
  width: 90%;
  max-width: 420px;
  border-radius: 24px;
  padding: 32px 28px;
  position: relative;
  z-index: 1000000;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.4s ease;
  overflow-y: auto;
  max-height: 90vh;
  -webkit-overflow-scrolling: touch;
}

.login-card input {
  -webkit-user-select: text !important;
  user-select: text !important;
  pointer-events: auto !important;
  touch-action: manipulation !important;
  position: relative;
  z-index: 1000001;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f3f4f6;
  border: none;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.3s ease;
  z-index: 10;
  line-height: 1;
}

.close-btn:hover {
  background: #e5e7eb;
  color: #1f2937;
  transform: rotate(90deg);
}

.primary-btn:active {
  transform: scale(0.98);
}

.mobile-bottom-nav {
  z-index: 998 !important;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@media (max-width: 480px) {
  .login-card {
    padding: 28px 20px;
    width: 95%;
  }
  .brand-title {
    font-size: 22px !important;
  }
  .otp-box input {
    width: 42px !important;
    height: 44px !important;
    font-size: 18px !important;
    border-radius: 10px !important;
  }
}

@media (max-width: 380px) {
  .otp-box {
    gap: 3px !important;
  }
  .otp-box input {
    width: 38px !important;
    height: 40px !important;
    font-size: 16px !important;
    border-radius: 8px !important;
  }
}
   
      `}</style>
    </>
  );
}